import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

const formatID = (raw) => {
  const digits = String(raw ?? "").replace(/\D/g, "");
  return digits ? Number(digits).toLocaleString("id-ID") : "";
};

export const CurrencyInput = forwardRef(function CurrencyInput({ value, onValueChange, ...props }, ref) {
  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    onValueChange?.(digits === "" ? "" : String(Number(digits)));
  };
  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      value={formatID(value)}
      onChange={handleChange}
      {...props}
    />
  );
});
